/*
 * @Author: yuanweijiang
 * @Date: 2025-11-22 14:03:27
 * @LastEditors: yuanweijiang
 */
// store/modules/guide.js
const state = {
    shouldOpenLayerModule: ''
}

const mutations = {
    SET_SHOULD_OPEN_LAYER_MODULE(state, value) {
        state.shouldOpenLayerModule = value
    }
}

const actions = {
    setShouldOpenLayerModule({ commit }, value) {
        commit('SET_SHOULD_OPEN_LAYER_MODULE', value)
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
